import AbstractWidget from 'ievv_jsbase/lib/widget/AbstractWidget'
import HttpDjangoJsonRequest from 'ievv_jsbase/lib/http/HttpDjangoJsonRequest'

export default class selectSchoolWidget extends AbstractWidget {
  constructor(element, widgetInstanceId) {
    super(element, widgetInstanceId)
    console.log(this.element)
    this.setupBoundFunctions()
    this.element.addEventListener('input', this.handleOnChangeEvent)
    this.inputTimeout = null
    this.value = ''
    this.selectableElements = []
    this.selectableListContainer = this.makeSelectableListContainer()
    this.otherLink = this.makeOtherLink()
    this.otherSelect = this.makeOtherSelect()
    this.element.parentNode.appendChild(this.selectableListContainer)
    this.element.parentNode.appendChild(this.otherLink)
    this.statusElement = this.makeStatusElement()
    this.loadInitialValue()
  }

  loadInitialValue () {
    const hiddenInput = this.element.parentNode.firstElementChild
    const hiddenValue = hiddenInput.value
    if (hiddenValue === '') {
      return
    }
    if (isNaN(hiddenValue)) {
      this.renderOtherSelect()
      this.otherSelect.value = hiddenValue
      hiddenInput.value = hiddenValue
    } else {
      // TODO: call api and get name of id
      this.requestInitialSchool(hiddenValue)
    }
  }

  makeSelectableListContainer () {
    const element = document.createElement('div')
    element.classList.add('search-select-list')
    return element
  }

  setupBoundFunctions () {
    this.handleOnChangeEvent = this.handleOnChangeEvent.bind(this)
    this.requestSchools = this.requestSchools.bind(this)
    this.makeOption = this.makeOption.bind(this)
  }

  requestSchools () {
    window.clearTimeout(this.inputTimeout)
    this.inputTimeout = null
    console.log(`/api/school/?query=${this.value}`)
    new HttpDjangoJsonRequest(`/api/school/?query=${this.value}`)
      .get()
      .then(response => {
        console.log(response.bodydata)
        if (response.bodydata.count === 0) {
          this.renderStatusIfNotAlreadyExists()
          this.setStatus('Fant ingen skoler', 'error')
        } else {
          this.removeStatusIfExists()
        }
        response.bodydata.response.forEach(data => {
          this.renderSelectableValue(`${data.name}, ${data.city}`, data.id)
        })
      })
      .catch(error => {
        console.error(error)
      })
  }

  requestInitialSchool (id) {
    new HttpDjangoJsonRequest(`/api/school/${id}`)
      .get()
      .then(response => {
        this.handleSelectSchool(id, `${response.bodydata.name}, ${response.bodydata.city}`)
      })
      .catch(error => {
        console.error(error)
      })
  }

  clearHiddenValue () {
    this.element.previousElementSibling.value = ''
  }

  handleSelectSchool (id, name) {
    this.element.previousElementSibling.value = `${id}`
    this.element.value = name
    console.log(this.element.previousSibling)
    this.clearAllSelectableElements()
  }

  handleOtherOnChange (value) {
    this.element.parentNode.firstElementChild.value = value
  }

  handleOnChangeEvent(event) {
    this.value = event.target.value
    this.clearAllSelectableElements()
    this.clearHiddenValue()
    this.renderStatusIfNotAlreadyExists()
    this.setStatus('Søker...')
    if (!this.element.parentNode.contains(this.otherLink)) {
      this.element.parentNode.appendChild(this.otherLink)
    }

    if (this.element.parentNode.contains(this.otherSelect)) {
      this.element.parentNode.removeChild(this.otherSelect)
    }

    if (this.inputTimeout) {
      window.clearTimeout(this.inputTimeout)
      this.inputTimeout = null
    }
    if (this.value !== '') {
      this.inputTimeout = window.setTimeout(this.requestSchools, 1000)
    } else {
      this.removeStatusIfExists()
    }
  }

  clearAllSelectableElements () {
    this.selectableElements.forEach(element => {
      this.selectableListContainer.removeChild(element)
    })
    this.selectableElements = []
  }

  renderSelectableValue (value, id) {
    const element = document.createElement('button')
    element.innerText = value
    element.classList.add('search-select-list')
    element.classList.add('search-select-list__item')
    element.type = 'button'
    element.addEventListener('click', () => {
      this.handleSelectSchool(id, value)
    })
    this.selectableListContainer.appendChild(element)
    this.selectableElements = [...this.selectableElements, element]
  }

  renderOtherSelect () {
    this.element.parentNode.removeChild(this.otherLink)
    this.element.parentNode.appendChild(this.otherSelect)
    this.clearAllSelectableElements()
    this.clearHiddenValue()
    this.removeStatusIfExists()
    this.otherSelect.value = ''
    this.element.value = ''
  }

  makeOtherLink () {
    const element = document.createElement('a')
    element.innerText = 'Jeg er ikke tilknyttet skole/institusjon'
    element.addEventListener('click', event => {
      event.preventDefault()
      this.renderOtherSelect()
    })
    return element
  }

  get otherOptionSpec () {
    return [
      {label: 'Hva gjør du?', value: '', disabled: true, defaultSelected: true},
      {label: 'Jeg leser selv', value: 'self-study', disabled: false, defaultSelected: false},
      {label: 'Annet', value: 'other', disabled: false, defaultSelected: false}
    ]
  }

  makeOtherSelect () {
    const element = document.createElement('select')
    element.classList.add('form-control')
    element.classList.add('c-square')
    element.classList.add('c-theme')
    element.classList.add('c-theme--outlined')
    element.style.marginTop = '1rem'
    element.style.display = 'block'
    element.value = ''
    this.otherOptionSpec.map(this.makeOption).forEach(option => {
      element.appendChild(option)
    })
    element.addEventListener('change', event => {
      this.handleOtherOnChange(event.target.value)
    })
    return element
  }

  makeStatusElement () {
    const element = document.createElement('span')
    element.classList.add('message')
    element.style.display = 'block'
    element.innerText = ''
    return element
  }

  setStatus (text, variant = '') {
    if (this.statusElement.innerText === text) {
      return
    }
    this.statusElement.classList.remove('message--error')
    this.statusElement.innerText = text
    if (variant !== '') {
      this.statusElement.classList.add(`message--${variant}`)
    }
  }

  renderStatusIfNotAlreadyExists () {
    if (!this.element.parentNode.contains(this.statusElement)) {
      this.element.parentNode.insertBefore(this.statusElement, this.selectableListContainer)
    }
  }

  removeStatusIfExists () {
    if (this.element.parentNode.contains(this.statusElement)) {
      this.element.parentNode.removeChild(this.statusElement)
    }
  }

  makeOption ({label, value, disabled, defaultSelected}) {
    const element = document.createElement('option')
    element.value = value
    element.innerText = label
    if (disabled) {
      element.disabled = true
    }
    if (defaultSelected) {
      element.defaultSelected = true
    }
    return element
  }
}



// WEBPACK FOOTER //
// ./source/widgets/SchoolSearchSelect.js